module.exports = __webpack_public_path__ + "media/earth.e7ede310.mp4";